import { Fragment, Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { insertProseMirrorContent } from './insert-node-helpers';
export var handleInsertContent = function handleInsertContent(_ref) {
  var node = _ref.node,
    options = _ref.options;
  return function (tr) {
    var _options$insertAt;
    var position = (_options$insertAt = options.insertAt) !== null && _options$insertAt !== void 0 ? _options$insertAt : tr.selection;
    if (!(node instanceof PMNode || node instanceof Fragment)) {
      return false;
    }
    insertProseMirrorContent({
      tr: tr,
      node: node,
      position: position,
      selectNodeInserted: options.selectNodeInserted
    });
    tr.scrollIntoView();
    return true;
  };
};